import React from 'react'
import { Route, Routes } from 'react-router-dom';
import "./mainPage.css"
import leftBanner from "../../images/leftBanner.png"
import pictograms from "../../images/pictograms.png"
import igIcon from "../../images/igIcon.svg"
import fbIcon from "../../images/fbIcon.svg"
import Welcome from '../welcomeContent/welcome';
import EnterCode from '../enterCode/enterCode';
import Mehanism from '../mehanismContent/mehanism';
import Prizes from '../prizeContent/prizes';
import Rules from '../rulesContent/rules';
import QuestionsAnswers from '../qaContent/questionsAnswers';
import Winners from '../winnersContent/winners';

function MainPage() {
    return (
        <div className="mainPage">
            <img src={leftBanner}
                className="leftBanner" />
            <img src={pictograms}
                className="pictograms" />

            <Routes>
                <Route path="/" element={<Welcome />} />
                <Route path="unesi-kod" element={<EnterCode />} />
                <Route path="/mehanizam" element={<Mehanism />} />
                <Route path="/nagrade" element={<Prizes />} />
                <Route path="/pravila" element={<Rules />} />
                <Route path="/pitanja-i-odgovori" element={<QuestionsAnswers />} />
                <Route path="/dobitnici" element={<Winners />} />
            </Routes>

            <div className="desktopIcons">
                <a href="https://www.instagram.com/zajecarsko.pivo/" target='_blank'>
                    <img src={igIcon} />
                </a>

                <a href="https://www.facebook.com/pivo.zajecarsko" target='_blank'>
                    <img src={fbIcon} />
                </a>
            </div>


        </div>
    )
}

export default MainPage

{/* */ }
